import { render, staticRenderFns } from "./audit-table.vue?vue&type=template&id=794b79fd&scoped=true&"
import script from "./audit-table.vue?vue&type=script&lang=js&"
export * from "./audit-table.vue?vue&type=script&lang=js&"
import style0 from "./audit-table.vue?vue&type=style&index=0&id=794b79fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b79fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VRow})
